import React from "react";

import { ReactComponent as WHATSAPPICON } from "../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as FACEBOOKICON } from "../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAM } from "../build/new-midias-icons/instagram.svg";
import { ReactComponent as VOZICON } from "../build/new-midias-icons/voz.svg";
import { ReactComponent as EMAILICON } from "../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICON } from "../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICON } from "../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICON } from "../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICON } from "../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICON } from "../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICON } from "../build/new-midias-icons/teams.svg";
import { ReactComponent as WHATSAPPVOZICON } from "../build/new-midias-icons/whatsapp-voz.svg";

export const renderCorrectMidia = {
  1: <VOZICON />,
  2: <WEBCHATICON />,
  3: <EMAILICON />,
  4: <FACEBOOKICON />,
  5: <WHATSAPPICON />,
  6: <INSTAGRAM />,
  8: <TELEGRAMICON />,
  9: <TWITTERICON />,
  10: <LINKEDINICON />,
  12: <SMSICON />,
  15: <TEAMSICON />,
  16: <WHATSAPPVOZICON />,
};
